import type { ClientConfig } from '@ferro/config';
import { StepAdminUser } from './_components/StepAdminUser.js';
import { StepBasicInfo } from './_components/StepBasicInfo.js';
import { StepBrand } from './_components/StepBrand.js';
import { StepConfig } from './_components/StepConfig.js';
import { StepDomain } from './_components/StepDomain.js';
import { StepModules } from './_components/StepModules.js';
import { StepReview } from './_components/StepReview.js';
import {
  defaultRenderStep,
  WizardShell,
  type WizardRenderProps,
} from './_components/WizardShell.js';

type TenantsNewProps = {
  config: ClientConfig;
};

/**
 * Platform-admin-only tenant provisioning wizard entry point.
 *
 * Mirrors the design-doc URL `admin.animalloversapp.com/admin/tenants/new`
 * (§8 of TENANT-PROVISIONING-DESIGN-2026-04-20.md). All 7 steps wired.
 */
export function TenantsNew({ config }: TenantsNewProps): JSX.Element {
  return (
    <WizardShell
      renderStep={(props: WizardRenderProps) => {
        if (props.step === 'basic-info') {
          return (
            <StepBasicInfo
              payload={props.payload}
              updatePayload={props.updatePayload}
              config={config}
            />
          );
        }
        if (props.step === 'domain') {
          return <StepDomain payload={props.payload} />;
        }
        if (props.step === 'brand') {
          return (
            <StepBrand
              payload={props.payload}
              updatePayload={props.updatePayload}
              config={config}
            />
          );
        }
        if (props.step === 'config') {
          return (
            <StepConfig
              payload={props.payload}
              updatePayload={props.updatePayload}
            />
          );
        }
        if (props.step === 'modules') {
          return (
            <StepModules
              payload={props.payload}
              updatePayload={props.updatePayload}
            />
          );
        }
        if (props.step === 'admin-user') {
          return (
            <StepAdminUser
              payload={props.payload}
              updatePayload={props.updatePayload}
            />
          );
        }
        if (props.step === 'review') {
          return (
            <StepReview
              payload={props.payload}
              config={config}
              onGoToStep={props.goToStep}
            />
          );
        }
        return defaultRenderStep(props);
      }}
    />
  );
}
